import { render, staticRenderFns } from "./StripeConnect.vue?vue&type=template&id=854ad3ae"
import script from "./StripeConnect.vue?vue&type=script&lang=js"
export * from "./StripeConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('854ad3ae')) {
      api.createRecord('854ad3ae', component.options)
    } else {
      api.reload('854ad3ae', component.options)
    }
    module.hot.accept("./StripeConnect.vue?vue&type=template&id=854ad3ae", function () {
      api.rerender('854ad3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/StripeConnect.vue"
export default component.exports